module.exports = __webpack_public_path__ + "img/programme3.49f28782.png";